"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTemplate = void 0;
/**
 * @example
 * parseTemplate('Hello {{name}}!', {name: 'John'})
 * parseTemplate('My city {{address.city}}', {address: {city: 'London'}})
 */
function parseTemplate(value, obj, 
/**
 * Provide a custom method for accessing the value from the
 * provided object
 */
accessor, returnOriginal) {
    if (value === void 0) { value = ''; }
    if (obj === void 0) { obj = {}; }
    if (!accessor) {
        accessor = function (key, entry) { return key
            .split('.')
            .reduce(function (acc, cur) {
            return acc[cur];
        }, entry); };
    }
    if (!value.includes('{{')) {
        return returnOriginal ? value : obj[value];
    }
    else {
        var lookUp = new RegExp("{{(.*?)}}");
        while (lookUp.test(value)) {
            value = value.replace(lookUp, accessor(RegExp.$1, obj));
        }
        return value;
    }
}
exports.parseTemplate = parseTemplate;
